import { batch } from 'react-redux';
import { get } from 'lodash';
import template from 'url-template';

import awsHeader from '../helpers/awsAuth';
import { getErrorMessage } from '../helpers/errors';
import { handleNetworkError } from './applicationMessageActions';
import k2aBaseApi from '../apis/key2act';

import {
    FETCH_SYSTEM_TYPES,
    SYSTEM_TYPES_LOAD_BEGIN,
    SYSTEM_TYPES_LOAD_END,
    SYSTEM_TYPES_LOAD_ERROR
} from '../actions/actionTypes';

const DEFAULT_LIMIT = 10000;
const SystemTypesUrl = template.parse('/system-types{?limit}');

export const fetchSystemTypes = (options = {}) => async (dispatch, getState) => {
    options.limit || (options.limit = DEFAULT_LIMIT);
    try {
        const header = await awsHeader();
        dispatch(beginLoading());
        const response = await k2aBaseApi.get(
            SystemTypesUrl.expand(options),
            header
        );
        const payload = get(response, 'data.data', []);
        dispatch({
            type: FETCH_SYSTEM_TYPES,
            payload
        });
    } catch (error) {
        batch(() => {
            dispatch(errorLoading(getErrorMessage(error)));
            dispatch(handleNetworkError(error));
        });
    } finally {
        dispatch(endLoading());
    }
};

const beginLoading = () => ({
    type:    SYSTEM_TYPES_LOAD_BEGIN,
    payload: null
});

const endLoading = () => ({
    type:    SYSTEM_TYPES_LOAD_END,
    payload: null
});

const errorLoading = (error) => ({
    type:    SYSTEM_TYPES_LOAD_ERROR,
    payload: error
});
